const getHeadingLevel = (el: HTMLElement) => {
	return Number(el.getAttribute('aria-level') ?? (/^H[1-6]$/.test(el.tagName) ? el.tagName.slice(1) : 2));
};

const isExposed = (el: HTMLElement) => {
	if (el.closest('[aria-hidden="true"], [inert], [role="none"], [role="presentation"]')) return false;
	return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && !!el.textContent?.trim();
};

const isOutsidePageChrome = (el: HTMLElement) => {
	return !el.closest('header, nav, footer, [role="banner"], [role="navigation"], [role="contentinfo"]');
};

export const focusMainContent = (fallbackToMain = true): boolean => {
	const main = document.querySelector<HTMLElement>('#root [role="main"]');
	const scope = main ?? document.querySelector<HTMLElement>('#root');
	if (!scope) return false;

	const headings = [...scope.querySelectorAll<HTMLElement>('h1, h2, h3, h4, h5, h6, [role="heading"]')].filter(el => {
		return !['none', 'presentation'].includes(el.getAttribute('role') ?? '') && isExposed(el) && (!!main || isOutsidePageChrome(el));
	});
	const target = headings.find(el => {
		return getHeadingLevel(el) === 1;
	}) ?? (main ? null : headings[0]) ?? (fallbackToMain ? main : null);
	if (!target) return false;

	if (!target.hasAttribute('tabindex')) {
		target.tabIndex = -1;
	}

	target.focus({ preventScroll: true });
	return document.activeElement === target;
};
